/**
 * Created by Victor Rojo on 9/5/19.
 */
import { Component }     from '@angular/core';

@Component({
  templateUrl: './Historic.component.html',
  styleUrls: ['./Historic.component.css']
})
export class HistoricComponent {

}
